import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import {
    Link,
  } from '@chakra-ui/react';
import {
  Link as GatsbyLink,
} from 'gatsby';

export const Logo = () => {

    return (
        <Link as={GatsbyLink} to='/'>
            <StaticImage
                height={50}
                src='../images/JamesonMovingLogo.png'
                alt='Jameson Moving & Storage Logo'
                placeholder='none'
            ></StaticImage>
        </Link>
    );
};
